import React from 'react';
import Suggester from 'src/components/Suggester';
import { useSuggestions } from 'src/hooks/useSuggestions';
import { MPEvents } from 'src/utils/mixpanel/types';
import { mpEvent } from 'src/utils/mixpanel';
import useActionsApp from 'src/redux/actionHooks/useActionsApp';

interface AiSuggestProps {
  wrapperStyle?: React.CSSProperties;
  scenarioId: string;
}

export const AiSuggest: React.FC<AiSuggestProps> = ({ wrapperStyle, scenarioId }) => {
  const { saveKeys, hiddenSuggestionKeys } = useSuggestions();
  const { setLinkControlsToScenarioModal } = useActionsApp();

  const isHidden = !!scenarioId && hiddenSuggestionKeys.includes(scenarioId);

  if (isHidden) return null;

  return (
    <div style={wrapperStyle}>
      <Suggester
        key={scenarioId}
        onClose={() => {
          const newKeys = [...hiddenSuggestionKeys, scenarioId!];
          saveKeys(newKeys);
        }}
        title={
          <span>
            See{' '}
            <span
              className="sg-action"
              data-cy="ai-suggest-control-link-controls"
              onClick={() => {
                setLinkControlsToScenarioModal({ activeTab: 'from_suggested' });
                mpEvent(MPEvents.ButtonClick, {
                  button: 'Suggested controls',
                  tags: ['SCENARIO', 'RMP', 'AI'],
                });
              }}
            >
              suggested controls
            </span>{' '}
            for this scenario.
          </span>
        }
      />
    </div>
  );
};
